// Electronic Signature (Sadq) — the register of signature requests the office
// raises, reviews, approves and follows up.
//
// The ids are the central key service's approval numbers, which
// `PermissionService::createAndGrantToOwners()` writes as each permission row's
// id — so these constants must stay equal to the ones
// `database/migrations/2026_09_13_000020_add_esign_permissions.php` produces,
// or the pages render for nobody.
//
// READ, NOT PREDICTED. The central key service approved all thirteen keys on
// 13 September 2026 and issued 1587-1599, following on from
// `contracts.ejar.import` (1586) — which is what the block was predicted as, but
// the prediction is not why they are written here. Never derive the next block
// from the last one: a predicted id has been wrong two of the three times it was
// predicted in this repo (booking-contract publish/delete came back 1512/1513
// rather than 1501/1502, print/send-confirmation 1517/1518 rather than
// 1514/1515), and a wrong one hides the page from everyone instead of failing.

/** esign.index — the register, one request's detail, and the manual "check Sadq now" */
export const ESIGN_INDEX = 1587;

/** esign.create — raise a signature request, from an upload or from a system document */
export const ESIGN_CREATE = 1588;

/** esign.update — edit a draft or a rejected request */
export const ESIGN_UPDATE = 1589;

/** esign.delete */
export const ESIGN_DELETE = 1590;

/** esign.restore */
export const ESIGN_RESTORE = 1591;

/** esign.submit_review — hand a draft to whoever approves */
export const ESIGN_SUBMIT_REVIEW = 1592;

/**
 * esign.approve — say the document may go out.
 *
 * Approving does NOT send it: the scheduled dispatch does, which is why there is
 * no separate "send" key. Split from `reject` deliberately — an office that lets
 * a supervisor turn back a bad draft does not necessarily let them release one.
 */
export const ESIGN_APPROVE = 1593;

/** esign.reject — send a request back with a reason */
export const ESIGN_REJECT = 1594;

/** esign.cancel — withdraw a request from Sadq; Sadq emails every party */
export const ESIGN_CANCEL = 1595;

/** esign.download — the signed document */
export const ESIGN_DOWNLOAD = 1596;

/** esign.resend — nudge the parties who have not signed yet */
export const ESIGN_RESEND = 1597;
